import { AxiosRequestConfig } from 'axios';
import instance, { PPR_API_URL } from 'api';
import { EStatusNames } from './interfaces';

export const getRealEstatePpr = (realEstateId: string, status: EStatusNames) => {
  return instance(true, PPR_API_URL)
    .get(`task/statusesByRealEstate/${realEstateId}/${status}`)
    .then((response) => response.data);
};

export const getListByRealEstatePpr = (config?: AxiosRequestConfig) => {
  return instance(true, PPR_API_URL)
    .get(`task/listByRealEstateAndStatus`, config)
    .then((response) => response.data);
};
